// extracted by mini-css-extract-plugin
export var productImage = "_nb-0";